import React from "react";
import { connect } from "react-redux";
import { Layout, Table, Button, Typography, Row, Col, Tooltip, Alert, Select, Input } from 'antd';
import { LeftCircleOutlined, SaveOutlined } from '@ant-design/icons';
import { getAllEmployee } from "services/employee-service";
import { Header, CardInfo } from "components";
import { useNavigate, useLocation } from "react-router-dom";

const { Footer, Content } = Layout;
const { Text } = Typography;

const mapStateToProps = (state) => ({
});

const DataFetch = {
    data: {
        employees: [],
        businessUnits: []
    },
    loading: false
}

const SolicitationEmployeeScreen = (props) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [data, setData] = React.useState(DataFetch);
    const [employees, setEmployees] = React.useState([]);
    const [filterEmployees, setFilterEmployees] = React.useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
    const [showMessageAccount, setShowMessageAccount] = React.useState(false);
    const [businessUnit, setBusinessUnit] = React.useState(-1);
    const [selectAll, setSelectAll] = React.useState(false);
    const benefit = state.benefit || null;
    const [searchValue, setSearchValue] = React.useState('');

    const load = async () => {
        setData((x) => ({ ...x, loading: true }));
        const res = await getAllEmployee(null, true);
        const filter = res.employees.filter(x => x.enabled);
        setEmployees(filter);
        setFilterEmployees(filter);
        setData({ data: res, loading: false });
    };

    const onFilter = (value) => {
        const lowercasedValue = value.toLowerCase();
        const filteredEmployees = employees.filter(employee => {
            return employee.name.toLowerCase().includes(lowercasedValue) ||
                employee.email.toLowerCase().includes(lowercasedValue) ||
                employee.cpf.replace(/[^\d]/g, '').includes(value)
        });

        setFilterEmployees(filteredEmployees);
    };

    const onContinue = () => {
        navigate(`save`, { state: { benefit: benefit, employees: employees.filter(x => selectedRowKeys.indexOf(x.id) > -1), businessUnit: businessUnit > 1 ? businessUnit : null } });
    };

    React.useEffect(() => {
        load();
    }, []);

    React.useEffect(() => {
        verifyUsersAccount();
        if (data.data.employees.length === 0 && data.data.businessUnits.length > 0) {
            filterBusinessUnit(data.data.businessUnits[0].id);
        }
    }, [data]);

    const verifyUsersAccount = () => {
        let length = data.data.employees.filter(u => u.account == null).length;
        setShowMessageAccount(length > 0);
    };

    const filterBusinessUnit = (value) => {
        setBusinessUnit(value);
        let users = [];
        if (value === -1) {
            users = data.data.employees.filter(x => x.enabled);
        } else {
            let filter = data.data.businessUnits.filter(x => x.id === value);
            users = filter.length > 0 ? filter[0].employees.filter(x => x.enabled) : [];
        }
        setEmployees(users);
        setFilterEmployees(users);
        setSelectedRowKeys([]);
    };

    React.useEffect(() => {
        let rows = selectAll ? employees.filter(user => user.accountStatus).map(user => user.id) : [];
        setSelectedRowKeys(rows);
    }, [selectAll, employees]);

    const columns = [
        {
            title: 'Nome',
            dataIndex: 'name',
            render: (value, row) => {
                if (!row.accountStatus) {
                    return <Tooltip placement="bottom" title={row.validation || "Dados pendentes de validação."}>
                        <Text mark>{value}</Text>
                    </Tooltip>
                }
                return value;
            }
        },
        {
            title: 'CPF',
            dataIndex: 'cpf',
            width: 150
        },
        {
            title: 'Email',
            dataIndex: 'email',
            width: 300
        }
    ];

    return (
        <Layout className="alymente-layout">
            <Header title="Selecione os participantes" subtitle="Selecione os participantes para os quais você quer fazer o pedido de carga.">
                <Row>
                    <Col lg={6} md={12}>
                        <CardInfo title="Selecionados" value={`${selectedRowKeys.length}/${employees.length}`} />
                    </Col>
                    <Col lg={18} md={12} align="right">
                        <Select placeholder="Selecione a Equipe..." defaultValue="0" value={businessUnit} onChange={filterBusinessUnit} style={{ width: 300, textAlign: "left" }}>
                            <Select.Option value={-1} key={1}>Todos os participantes</Select.Option>
                            {
                                data.data && data.data.businessUnits ?
                                    data.data.businessUnits.map((x, index) => <Select.Option value={x.id} key={index + 2}>{x.name}</Select.Option>) : null
                            }
                        </Select>
                    </Col>
                </Row>
            </Header>
            <Content>
                <Table
                    rowKey={"id"}
                    rowSelection={{
                        selectedRowKeys: selectedRowKeys,
                        onChange: (items) => {
                            if (filterEmployees.length > 0) {
                                var newItems = [...selectedRowKeys];
                                for (let i of filterEmployees) {
                                    if (items.filter(f => f === i.id).length > 0 && selectedRowKeys.filter(s => s === i.id).length === 0)
                                        newItems.push(i.id);
                                    else if (items.filter(f => f === i.id).length === 0 && selectedRowKeys.filter(s => s === i.id).length > 0) {
                                        newItems.splice(newItems.findIndex(f => f === i.id), 1);
                                    }
                                }
                                setSelectedRowKeys(newItems);
                            } else {
                                setSelectedRowKeys(items);
                            }
                        },
                        getCheckboxProps: (row) => ({
                            disabled: !row.accountStatus
                        })
                    }}
                    title={() => (
                        <Row>
                            <Col xs={12}>
                                <Button style={{ marginRight: 10 }} size="small" type={"primary"} onClick={() => setSelectAll(!selectAll)}>
                                    {selectAll ? "Limpar Todos" : "Selecionar Todos"}
                                </Button>
                                <Typography.Text>Selecionados: {selectedRowKeys.length}/{employees.length}</Typography.Text>
                            </Col>
                            <Col xs={6} style={{ marginLeft: 'auto' }}>
                                <Input
                                    allowClear
                                    value={searchValue}
                                    onChange={e => {
                                        setSearchValue(e.target.value);
                                        onFilter(e.target.value);
                                    }}
                                    placeholder="Digite sua pesquisa..."
                                />
                            </Col>
                        </Row>
                    )}
                    pagination={{ defaultPageSize: 1000 }}
                    scroll={{ y: 400 }}
                    dataSource={filterEmployees}
                    loading={data.loading}
                    bordered
                    columns={columns}
                />
            </Content>
            <Footer>
                <Row  style={{width: '100%'}} justify="space-between">
                    <Button className="btn-save" type="primary" onClick={() => {
                        navigate(-1);
                    }}>Voltar</Button>
                    <Button disabled={selectedRowKeys.length < 1} className="btn-save" type="primary" icon={<SaveOutlined />} onClick={onContinue}>Continuar</Button>
                </Row>
            </Footer>
        </Layout >
    );
}

export default connect(mapStateToProps, {})(SolicitationEmployeeScreen);
